import {Component} from '@angular/core';
import {AuthService} from "../../shared/services/auth.service";
import {FormBuilder, FormGroup} from '@angular/forms';
import { GoogleAnalyticsService } from '../../shared/services/google-analytics.service';
import { ResetPasswordValidation } from '../../shared/validations/reset-password.validation';
import { verifiedImage, emailIcon } from '../../utils/images';
import appConfig from '../../shared/config/app-config';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})

export class ResetPasswordComponent {

  form: FormGroup;

  public errorMessage: string = ""

  public hideForm: boolean = false

  public loader: boolean = false

  verifiedImage = verifiedImage
  emailIcon = emailIcon
  vettimesDomain = appConfig.vettimesDomain

  constructor(private authService: AuthService, private googleAnalytics: GoogleAnalyticsService, private formBuilder: FormBuilder) {
    this.form = ResetPasswordValidation.createResetPasswordForm(this.formBuilder);
  }

  resetPassword() {
    this.form.markAllAsTouched()
    if (this.form.invalid) return

    let {email} = this.form.value
    this.loader = true;

    this.authService.forgotPassword({email}).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.loader = false;
          this.hideForm = true
        }
      },
      error => {
        this.loader = false;
        this.form.get('email')?.setErrors({apiError: true})
        this.errorMessage = error.error.errors
      }
    );
  }

  trackButtonClick(btn_name: any) {
    this.form.markAllAsTouched()
    if (this.form.invalid) return
    this.googleAnalytics.trackButtonClick({'button': btn_name, page: 'Reset password'});
  }
}
